"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesVariantMatch = doesVariantMatch;
exports.getVariantsFromCookies = getVariantsFromCookies;
exports.getVariantsFromQueryParams = getVariantsFromQueryParams;
exports.isMobile = isMobile;
exports.isMobileVariant = isMobileVariant;
exports.isVariantPresent = isVariantPresent;
var _js = require("../utils/js");
function doesVariantMatch(whichValue, variants) {
  whichValue = whichValue.toLowerCase();
  if (variants.length === 0 && whichValue === "original") {
    return true;
  }
  for (let i = 0; i < variants.length; i++) {
    if (whichValue === variants[i].toLowerCase() || whichValue === "original") {
      return true;
    }
  }
  return false;
}
function getVariantsFromQueryParams() {
  let variants = [];
  const params = (0, _js.getURIQueryParams)();
  if (params.variant) {
    variants = decodeURIComponent(params.variant).split(",");
  }
  return variants;
}
function getVariantsFromCookies() {
  let cookieNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let variants = [];
  for (let i = 0; i < cookieNames.length; i++) {
    const value = getCookie(cookieNames[i]);
    if (value) {
      variants.push(value);
    }
  }
  return variants;
}
function isVariantPresent(whichVariant) {
  whichVariant = whichVariant.toLowerCase();
  return getVariantsFromQueryParams().toLowerCase().indexOf(whichVariant) > -1;
}
function isMobile() {
  const body = document.querySelector("body");
  const windowWidth = window.innerWidth;
  const bodyWidth = body.offsetWidth <= windowWidth ? body.offsetWidth : windowWidth;
  const style = getComputedStyle(body);
  const marginLeft = parseInt(style.marginLeft, 10);
  const marginRight = parseInt(style.marginRight, 10);
  const width = marginLeft + bodyWidth + marginRight;
  return width <= parseInt(_js.mediaBreakpoints.forPhoneOnly.split(": ")[1].split("px")[0], 10);
}
function isMobileVariant(whichVariant) {
  return isMobile && isVariantPresent(whichVariant);
}
function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}